import mapboxgl from 'mapbox-gl'

export const appName = process.env.REACT_APP_NAME

export const defaltMapPayload = {
  center: new mapboxgl.LngLat(139.78892467921216, 35.68524929651115),
  zoom: 15
}

export const mapboxAccessToken = 'pk.eyJ1IjoiY3RpZS15YWdhbWkiLCJhIjoiY20zd2cwMm9tMTM4bzJqczk2bDY2aG15ZyJ9.Ie-ZDIgaPaEfQwFj0_mPtA'
